import { z } from 'zod'

import { TaxReceiptType, ZReceiptInformation } from '@/entities/user'
import { isNilOrEmptyString } from '@/shared/lib'

export const RECEIPT_INFORMATION_FIELDS = [
  'receiptRequested',
  'taxReceiptType',
  'personalIssuanceNumber',
  'businessIssuanceNumber',
  'corpId',
  'corpName',
  'corpCeo',
  'invoiceeEmail',
]

export const ZReceiptInformationFormValues = ZReceiptInformation.pick({
  taxReceiptType: true,
  corpId: true,
  corpName: true,
  corpCeo: true,
  invoiceeEmail: true,
}).extend({
  receiptRequested: z.enum(['true', 'false']).nullable(),
  personalIssuanceNumber: z.string().nullable(),
  businessIssuanceNumber: z.string().nullable(),
})

export type TReceiptInformationFormValues = z.infer<
  typeof ZReceiptInformationFormValues
>

export const ReceiptInformationValidation = (
  data: TReceiptInformationFormValues,
  ctx: z.RefinementCtx,
) => {
  if (data.receiptRequested === null) {
    ctx.addIssue({
      path: ['receiptRequested'],
      code: z.ZodIssueCode.custom,
      message: '영수증 발급 신청 정보를 선택해 주세요.',
    })
  }

  if (data.receiptRequested === 'false') {
    return
  }

  if (data.taxReceiptType === TaxReceiptType.CASH_RECEIPT_PERSONAL) {
    if (isNilOrEmptyString(data.personalIssuanceNumber)) {
      ctx.addIssue({
        path: ['personalIssuanceNumber'],
        code: z.ZodIssueCode.custom,
        message: '휴대폰 번호 또는 현금영수증 카드 번호를 입력해 주세요.',
      })
    }
  }

  if (data.taxReceiptType === TaxReceiptType.CASH_RECEIPT_BUSINESS) {
    if (isNilOrEmptyString(data.businessIssuanceNumber)) {
      ctx.addIssue({
        path: ['businessIssuanceNumber'],
        code: z.ZodIssueCode.custom,
        message: '휴대폰 번호 또는 사업자 등록번호를 입력해 주세요.',
      })
    }
  }

  if (data.taxReceiptType === TaxReceiptType.TAX_INVOICE) {
    if (isNilOrEmptyString(data.corpId)) {
      ctx.addIssue({
        path: ['corpId'],
        code: z.ZodIssueCode.custom,
        message: '사업자 등록번호를 입력해 주세요.',
      })
    }
    if (isNilOrEmptyString(data.corpName)) {
      ctx.addIssue({
        path: ['corpName'],
        code: z.ZodIssueCode.custom,
        message: '사업자명을 입력해 주세요.',
      })
    }
    if (isNilOrEmptyString(data.corpCeo)) {
      ctx.addIssue({
        path: ['corpCeo'],
        code: z.ZodIssueCode.custom,
        message: '대표자 이름을 입력해 주세요.',
      })
    }
  }
}

export const ZReceiptInformationForm =
  ZReceiptInformationFormValues.superRefine(ReceiptInformationValidation)

export const receiptInformationDefaultValues = {
  receiptRequested: null,
  taxReceiptType: null,
  personalIssuanceNumber: '',
  businessIssuanceNumber: '',
  corpId: '',
  corpName: '',
  corpCeo: '',
  invoiceeEmail: '',
}
